import { render, staticRenderFns } from "./UpdateOptionProduct.vue?vue&type=template&id=4eae2b33&scoped=true"
import script from "./UpdateOptionProduct.vue?vue&type=script&lang=js"
export * from "./UpdateOptionProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eae2b33",
  null
  
)

export default component.exports